<template>
    <div>
        {{ getType() }}
        <span v-html="$t('notification.channelCreated', { name: $_.get(activity, 'actorUser.name'), channel:$_.get(activity, 'payload.name') })"></span>
    </div>

</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "ChannelCreated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        getType() {
            return {
                "whatsapp-business-api": " Whatsapp Business API",
                telegram: "Telegram",
                "whatsapp-qr": "Whatsapp V1",
                "whatsapp-v2": "Whatsapp V2",
                "sms-postacell": "SMS Postacell",
                openai: "OpenAI",
            }[this.activity.payload.type];
        },
    },
});
</script>

<style scoped lang="scss"></style>
